import { createSlice } from "@reduxjs/toolkit";
import API, { ENDPOINTS } from "../../services/api";
import { axiosInstance, setSubscriptionId } from "../authentication/userSlices";
import { environment } from "../../environment";

export enum LocalStorageKeys {
  userToken = "userToken",
}

const initialState = {
  shops:[],
  detailedShops: [],
  newShopDetails: {
    name: "",
    address: "",
  },
  shopToEdit: null,
  shopToChangePlan: null,
  activityLog: [],
  notifications: []
};

export const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    setShops: (state, action) => {
      state.shops = action.payload;
    },
    setDetailedShops: (state, action) => {
      state.detailedShops = action.payload;
    },
    setNewShopDetails: (state, action) => {
      state.newShopDetails = action.payload;
    },
    setShopToEdit: (state, action) => {
      state.shopToEdit = action.payload;
    },
    setShopToChangePlan: (state, action) => {
      state.shopToChangePlan = action.payload;
    },
    setActivityLog: (state, action) => {
      state.activityLog = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    }
  }
});

export const getShops = () => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.get(`${environment.serverURL}/shops`)
    if (res.status === 200) {
      const formattedData = res.data.map(d =>{d.checked = false;return d})
      dispatch(setShops(formattedData));
    }
  } catch (error) {
    console.error(error);
  }
};
export const getDetailedShops = () => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.get(`${environment.serverURL}/shops/detailed`)
    if (res.status === 200) {
      dispatch(setDetailedShops(res.data));
    }
  } catch (error) {
    console.error(error);
  }
};
export const getShopsByUser = (userId) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.get(`${environment.serverURL}/shops/user/${userId}`)
    if (res.status === 200) {
      const formattedData = res.data.map(d =>{d.checked = false;return d})
      dispatch(setShops(formattedData));
    }
  } catch (error) {
    console.error(error);
  }
};

export const updateShopConfig = (shopId, config) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.post(`${environment.serverURL}/shops/${shopId}/config`, {id: shopId, forecast_config: JSON.stringify(config)})
    if (res.status === 200) {
      console.log(res.data, 'dataa')
      dispatch(getShops());
    }
  } catch (error) {
    console.error(error);
  }
}
export const createShop = (name, address, user_id, subscriptionId, selectedPlan) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.post(`${environment.serverURL}/shops/`, {name, address, user_id, subscriptionId, plan: selectedPlan})
    if (res.status === 201) {
      dispatch(getShops());
      window.location.reload();
    }
  } catch (error) {
    console.error(error);
  }
};
export const deleteShop = ({shopId, userId}) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.delete(`${environment.serverURL}/shops/${shopId}`)
    if (res.status === 200) {
      dispatch(getShopsByUser(userId));
    }
  } catch (error) {
    console.error(error);
  }
};

export const updateShop = (shopId, name, address, userId) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.put(`${environment.serverURL}/shops/${shopId}`, {id: shopId, name, address})
    if (res.status === 200) {
      dispatch(getShopsByUser(userId));
    }
  } catch (error) {
    console.error(error);
  }
}

export const getActivityLog = (shopId) => async (dispatch: Function) => {
  try { 
    const res = await axiosInstance.get(`${environment.serverURL}/shops/${shopId}/activity-log`)
    if (res.status === 200) {
      dispatch(setActivityLog(res.data));
    }
  } catch (error) {
    console.error(error);
  }
}

export const getNotifications = (shopId, totalLiters, date) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.get(`${environment.serverURL}/shops/${shopId}/notifications`, {params: {total_liters: totalLiters, date: date}})
    if (res.status === 200) {
      dispatch(setNotifications(res.data));
    }
  } catch (error) {
    console.error(error);
  }
}
export const changeShopPlan = (shopId, plan) => async (dispatch: Function) => {
  try {
    const res = await axiosInstance.post(`${environment.serverURL}/payments/change-subscription-plan/${shopId}`, {plan})
    if (res.status === 200) {
      dispatch(getShops());
    }
  } catch (error) {
    console.error(error);
  }
}

export const {
  setShops,
  setDetailedShops,
  setNewShopDetails,
  setShopToEdit,
  setShopToChangePlan,
  setActivityLog,
  setNotifications
} = shopSlice.actions;

export default shopSlice.reducer;
